const config = {
    // Em produção, usa a URL relativa (mesmo domínio)
    // Em desenvolvimento, usa localhost
    apiURL: process.env.NODE_ENV === 'production' 
        ? '/api' 
        : 'http://localhost:5000/api',
    // outras configurações aqui
};

export default config; 